export const DISPLAY = {
  width: 960,
  height: 720,
  hudHeight: 136,
  near: 0.25,
  far: 160,
  horizontalFovRadians: (62 * Math.PI) / 180,
  cameraHeight: 2.4,
  maxPixelRatio: 2,
} as const;

export const LOOP = {
  fixedStep: 1 / 60,
  maxFrameDelta: 0.1,
  maxUpdatesPerFrame: 6,
} as const;

export const PLAYER = {
  forwardSpeed: 9,
  reverseMultiplier: 0.72,
  pivotRate: (82 * Math.PI) / 180,
  treadRampSeconds: 0.1,
  radius: 1.35,
  shellSpeed: 48,
  shellRange: 115,
  muzzleClearance: 2,
} as const;

export const WORLD = {
  activeCellRadius: 4,
  shellHeight: 2.4,
  particleLimit: 80,
} as const;

export const FLOW = {
  readyDuration: 1.6,
  lifeLostDuration: 1.8,
  spawnProtection: 1.25,
  threatIntermissionMin: 1,
  threatIntermissionMax: 1.8,
} as const;

export const THREATS = {
  spawnMin: 52,
  spawnMax: 88,
  scoutSpeed: 4.2,
  siegeSpeed: 8,
  missileStartSpeed: 14,
  missileTopSpeed: 18,
  enemyShellSpeed: 24,
  enemyShellRange: 125,
  scoutAimTime: 0.8,
  siegeAimTime: 0.48,
  scoutCooldown: [2.6, 3.4] as const,
  siegeCooldown: [1.8, 2.5] as const,
  enterWarning: 1.1,
  skimmerCooldown: [18, 34] as const,
  skimmerVisit: 10,
} as const;

export const SCORING = {
  scout: 1_000,
  missile: 2_000,
  siege: 3_000,
  skimmer: 5_000,
  bonusThresholds: [15_000, 100_000] as const,
} as const;

export const RADAR = {
  revolutionSeconds: 2,
  blipPersistence: 1.1,
  range: 100,
} as const;

export const COLORS = {
  background: '#020807',
  phosphor: '#7dff9d',
  phosphorHot: '#d8ffe1',
  command: '#ff7657',
  commandHot: '#ffd0b4',
  dim: '#285a3a',
} as const;
